import api from '@/common/api';
import { str2Int } from '@/common/utils';
import RouteKey from '@/common/RouteKey';
import MessageType from '@/components/common/message-box/MessageType';
import { backwardSupportValidate } from '@/common/ValidationUtils';
import { OptionMapper, KeyEnum } from '@/common/OptionConstant';
import FormItemUploadFile from '../common/FormItemUploadFile';
import ErrorHandler from './ErrorHandler';
import Bubble from '../common/Bubble';
import tipConstant from '../data/TipConstant';

const ApplyType = {
  TEST: '1',
  PRO: '2'
};
const ConfirmMessage = {
  [ApplyType.TEST]: '请确保所填写信息的准确性',
  [ApplyType.PRO]: '申请正式授权前请确保已和优图谈好合作方案'
};
const Labletext = {
  [KeyEnum.JoinWay.INTERNAL]: '合作备案',
  [KeyEnum.JoinWay.EXTERNAL]: '合同文件'
};
const TENCENT_EXTERNAL_PROPS = [
  'scene',
  'applytype',
  'scope',
  'peercontact',
  'extname',
  'exturl',
  'ytcontact',
  'mailreceiver'
];
const TENCENT_INTERNAL_PROPS = [
  'scene',
  'applytype',
  'scope',
  'ytcontact',
  'intdept',
  'peercontact',
  'mailreceiver'
];
const IS_SUCCESS = 'is-success';
const IS_ERROR = 'is-error';
export default {
  name: 'YoutuBoxCreator',
  components: {
    FormItemUploadFile,
    Bubble
  },
  data() {
    return {
      tipConstant,
      businessLicenceError: {
        status: false,
        text: ''
      },
      contractError: {
        status: false,
        text: ''
      },
      OptionMapper,
      KeyEnum,
      newYoutuBoxData: {
        scene: '',
        scope: '',
        applytype: '',
        ytcontact: '',
        peercontact: '',
        exturl: '',
        extname: '',
        intdept: '',
        mailreceiver: ''
      },
      contractText: Labletext[KeyEnum.JoinWay.EXTERNAL],
      ApplyType,
      rules: {
        scene: [{
          required: true,
          message: '请输入应用简介',
          trigger: 'change'
        }, {
          max: 600,
          message: '不超过600字',
          trigger: 'change'
        }, {
          validator: backwardSupportValidate,
          trigger: 'change'
        }],
        applytype: [{
          required: true,
          message: '请选择申请类型, 测试或正式',
          trigger: 'change'
        }],
        extname: [{
          type: 'string',
          required: true,
          message: '请输入企业名称',
          trigger: 'change'
        }, {
          validator: backwardSupportValidate,
          trigger: 'change'
        }],
        exturl: [{
          type: 'string',
          required: true,
          message: '请输入公司网址',
          trigger: 'change'
        }, {
          validator: backwardSupportValidate,
          trigger: 'change'
        }],
        ytcontact: [{
          required: true,
          message: '请输入优图接口人邮箱',
          trigger: ['change', 'blur']
        }, {
          validator: ErrorHandler.validateMail,
          trigger: ['change', 'blur']
        }],
        intdept: [{
          required: true,
          message: '请输入业务所属部门'
        }, {
          max: 100,
          trigger: 'blur',
          message: '不超过100字'
        }, {
          validator: backwardSupportValidate,
          trigger: ['change', 'blur']
        }],
        youtucontacts: [{
          required: true,
          message: '请输入优图接口人邮箱',
          trigger: ['change', 'blur']
        }, {
          validator: ErrorHandler.validateMail,
          trigger: ['change', 'blur']
        }],
        peercontact: [{
          required: true,
          message: '请输入业务接口人及联系方式'
        }, {
          max: 100,
          trigger: 'blur',
          message: '不超过100字'
        }, {
          validator: backwardSupportValidate,
          trigger: ['change', 'blur']
        }],
        scope: [{
          required: true,
          trigger: 'change',
          message: '请选择业务主体'
        }],
        mailreceiver: [{
          required: true,
          message: '请输入业务方邮箱列表',
          trigger: ['change', 'blur']
        }, {
          validator: ErrorHandler.validateMail,
          trigger: ['change', 'blur']
        }]
      },
      validateFileLicence: false,
      ErrorNameLicence: 'LICENCE',
      validateLicenceFileResult: {
        file: null,
        legal: false
      },
      validateFileContract: false,
      ErrorNameContract: 'CONTRACT',
      validateContractFileResult: {
        file: null,
        legal: false
      },
      defaultExternal: true,
      showInnerTable: false,
      latestID: 0
    };
  },
  methods: {
    handleValidateUploadResultLicence(data, noValidate) {
      let classItems = this.$refs.licence.$el.classList;
      this.handleValidateUploadResult(data, classItems, noValidate, this.validateLicenceFileResult);
    },
    handleValidateUploadResultContract(data, noValidate) {
      let classItems = this.$refs.contract.$el.classList;
      this.handleValidateUploadResult(data, classItems, noValidate, this.validateContractFileResult);
    },
    handleValidateUploadResult(data, classItems, noValidate, filesResult) {
      if (data.result === true || data.file != null) {
        classItems.add(IS_SUCCESS);
        classItems.remove(IS_ERROR);
        filesResult.legal = data.result;
        filesResult.file = data.file;
        return;
      }
      if (noValidate) {
        classItems.remove(IS_ERROR);
        classItems.remove(IS_SUCCESS);
        filesResult.file = null;
        filesResult.legal = false;
        return;
      }
      classItems.add(IS_ERROR);
      classItems.remove(IS_SUCCESS);
      filesResult.file = null;
      filesResult.legal = false;
    },
    handleSubmitBox() {
      let form = this.$refs.newYoutuBoxData;
      this.validateFileContract = !(this.validateFileContract);
      // this.validateFileLicence = !(this.validateFileLicence);
      let boxData = this.newYoutuBoxData;
      if (boxData.scope === KeyEnum.JoinWay.INTERNAL) {
        let validateInner = TENCENT_INTERNAL_PROPS.map((fieldName) => {
          return this.wrapperValidate(form, fieldName);
        });
        if (boxData.applytype === ApplyType.TEST) { // 测试
          Promise.all(validateInner).then(() => {
            this.confirmSubmit();
          });
        } else { // 正式
          if (this.validateContractFileResult.legal === false) {
            return;
          }
          Promise.all(validateInner).then(() => {
            this.confirmSubmit();
          });
        }
        return;
      }
      let validateExternal = TENCENT_EXTERNAL_PROPS.map((fieldName) => {
        return this.wrapperValidate(form, fieldName);
      });
      if (boxData.applytype === ApplyType.TEST) { // 测试
        // if (this.validateLicenceFileResult.legal === false) {
        //   return;
        // }
        Promise.all(validateExternal).then(() => {
          this.confirmSubmit();
        });
      } else { // 正式
        if (this.validateContractFileResult.legal === false) {
          return;
        }
        Promise.all(validateExternal).then(() => {
          this.confirmSubmit();
        });
      }
    },
    confirmSubmit() {
      let applyType = this.newYoutuBoxData.applytype;
      this.$confirm(ConfirmMessage[applyType], '提交审核', MessageType.INFO).then(() =>
        this.doSubmitProcess()
      );
    },
    wrapperValidate(form, fieldName) {
      return new Promise((resolve, reject) => {
        form.validateField(fieldName, function(message) {
          if ((message == null || message.length === 0)) {
            resolve();
            return;
          }
          reject(message);
        });
      });
    },
    doSubmitProcess() {
      const loading = this.loading();
      let data = this.prepareSubmitData();
      let newYoutuBoxData = this.newYoutuBoxData;
      let files = {
        extlicense: this.validateLicenceFileResult.file,
        contract: this.validateContractFileResult.file
      };
      if (newYoutuBoxData.scope === KeyEnum.JoinWay.INTERNAL) {
        if (newYoutuBoxData.applytype === ApplyType.TEST) {
          this.validateLicenceFileResult.file = null;
          this.validateContractFileResult.file = null;
        }
      } else {
        if (newYoutuBoxData.applytype === ApplyType.TEST) {
          this.validateContractFileResult.file = null;
        }
      }
      this.$loader.upload(api.ytbox.CREATE_YTBOX, data, files, this.ajaxErrorCallback).then(() => {
        this.$alert('优图盒子授权已提交审核，审核通过后请绑定设备', null, MessageType.SUCCESS).then(() => {
          loading.close();
          this.$router.transfer(RouteKey.OPEN_YOUTU_BOX_DISPLAY);
        });
      }).finally(() => {
        loading.close();
      });
    },
    prepareSubmitData() {
      let newYoutuBoxData = this.newYoutuBoxData;
      let data = {
        ...newYoutuBoxData
      };
      data.id = this.latestID;
      data.applytype = str2Int(newYoutuBoxData.applytype);
      data.scope = str2Int(newYoutuBoxData.scope);
      if (data.mailreceiver.charAt(data.mailreceiver.length - 1) === ';' || data.mailreceiver.charAt(data.mailreceiver.length - 1) === '；') {
        data.mailreceiver = data.mailreceiver.substring(0, data.mailreceiver.length - 1);
      } else {
        data.mailreceiver = data.mailreceiver;
      }
      if (data.ytcontact.charAt(data.ytcontact.length - 1) === ';' || data.ytcontact.charAt(data.ytcontact.length - 1) === '；') {
        data.ytcontact = data.ytcontact.substring(0, data.ytcontact.length - 1);
      } else {
        data.ytcontact = data.ytcontact;
      }
      if (data.scope === KeyEnum.JoinWay.EXTERNAL) {
        delete data.intdept;
        // delete data.youtucontacts;
        return data;
      }
      // data.ytcontact = data.youtucontacts;
      delete data.extname;
      delete data.exturl;
      // delete data.youtucontacts;
      return data;
    },
    getBoxInfo() {
      if (this.$route.query.id == null || this.$route.query.id === 0) {
        return;
      }
      this.latestID = this.$route.query.id;
      this.$loader.post(api.ytbox.GET_YTBOX_INFO, {id: this.latestID}, this.ajaxErrorCallback).then(res => {
        this.newYoutuBoxData = {
          scene: res.scene,
          scope: res.scope,
          applytype: String(res.applytype),
          extname: res.extname,
          exturl: res.exturl,
          intdept: res.intdept,
          peercontact: res.peercontact,
          ytcontact: res.ytcontact == null ? res.ytcontact : res.ytcontact.replace(/,/g, ';'),
          mailreceiver: res.mailreceiver == null ? res.mailreceiver : res.mailreceiver.replace(/,/g, ';')
        };
      });
    }
  },
  watch: {
    newYoutuBoxData: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal.scope === KeyEnum.JoinWay.INTERNAL) {
          this.defaultExternal = false;
          this.showInnerTable = true;
          this.contractText = Labletext[KeyEnum.JoinWay.INTERNAL];
          this.ErrorNameContract = 'COOPREAT';
          this.validateFileContract = false;
        } else {
          this.defaultExternal = true;
          this.showInnerTable = false;
          this.contractText = Labletext[KeyEnum.JoinWay.EXTERNAL];
          this.ErrorNameContract = 'CONTRACT';
          this.validateFileContract = false;
        }
      },
      deep: true
    }
  },
  created() {
    this.ajaxErrorCallback = ErrorHandler.ajaxErrorCallback(this);
    this.handleSubmitBox = this.handleSubmitBox.bind(this);
    this.getBoxInfo();
  }
};



// WEBPACK FOOTER //
// ./src/components/open/panels/application/panels/js/YoutuBoxCreator.js